/**
 * @Description 条件筛选右侧的tab切换（条件筛选、图层设置）
 */
import { FC } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import { leftTab } from '../../../ts-config';
import { Badge } from 'antd';
const ChangeTab:FC<any> = ({
  setTabActive,
  tabActive,
  curLeftSection
}) => {

  return <div className={styles.changeTabCon}>
    <div>
      <Badge
      // 初始值从1开始是因为排名规则的单选
        count={curLeftSection?.reduce((pre, item) => pre + (item.count || 0), 0)}
        size='small'
        overflowCount={10}
        style={{
          zIndex: 5
        }}
      >
        <div className={cs(styles.box,)}>
          <div
            onClick={() => setTabActive(leftTab.condition)}
            className={cs(styles.card, tabActive === leftTab.condition ? styles.active : '')}>
            <span className='fs-10'>筛选点位</span>
          </div>
        </div>
      </Badge>
    </div>
    <div
      style={{
        position: 'absolute',
        top: 64 // 74-10
      }}
    >
      <div className={cs(styles.box, styles.bottom)}>
        <div
          onClick={() => setTabActive(leftTab.layer)}
          className={cs(styles.card, tabActive === leftTab.layer ? styles.active : '')}>
          <span className='fs-10'>图层设置</span>
        </div>
      </div>
    </div>
  </div>;
};
export default ChangeTab;
